import { Controller } from "@hotwired/stimulus"

// Mobile newsletter bottom sheet.
//
// Markup: data-controller="newsletter-sheet" wraps the CTA bar and the sheet.
// The "Newsletter" link points at #newsletter-sheet, so the sheet still opens
// via :target without JavaScript; this controller adds focus handling, Escape
// to close, scroll locking and a clean URL.
export default class NewsletterSheetController extends Controller {
  static targets = ["sheet", "trigger", "input"]

  connect() {
    this.handleKeydown = this.handleKeydown.bind(this)
    const isMobileLayout = window.matchMedia("(max-width: 720px)").matches
    if (isMobileLayout && window.location.hash === "#newsletter-sheet") {
      this.open()
    } else {
      this.sheetTarget.setAttribute("aria-hidden", "true")
    }
  }

  disconnect() {
    document.removeEventListener("keydown", this.handleKeydown)
    document.body.classList.remove("has-open-sheet")
  }

  open(event) {
    if (event) event.preventDefault()
    this.sheetTarget.classList.remove("is-closed")
    this.sheetTarget.classList.add("is-open")
    this.sheetTarget.removeAttribute("aria-hidden")
    document.body.classList.add("has-open-sheet")
    document.addEventListener("keydown", this.handleKeydown)
    if (this.hasInputTarget) this.inputTarget.focus()
  }

  close(event) {
    if (event) event.preventDefault()
    this.sheetTarget.classList.remove("is-open")
    this.sheetTarget.classList.add("is-closed")
    this.sheetTarget.setAttribute("aria-hidden", "true")
    document.body.classList.remove("has-open-sheet")
    document.removeEventListener("keydown", this.handleKeydown)
    if (window.location.hash === "#newsletter-sheet") {
      history.replaceState(null, "", window.location.pathname + window.location.search)
    }
    if (this.hasTriggerTarget) this.triggerTarget.focus()
  }

  handleKeydown(event) {
    if (event.key === "Escape") this.close()
  }
}
